import $api from "../http";
import { AxiosResponse } from "axios";

export default class AlumniService {

    static getVideos(page: number): Promise<AxiosResponse<any>> {
        return $api.get<any>(`api/alumni/?page=${page}`)
    };

    static getVideo(id: number): Promise<AxiosResponse<any>> {
        return $api.get<any>(`api/alumni/${id}`)
    };

    static getAllVideos(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/alumni/spec/?all=true')
    };

    static getSpecVideos(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/alumni/spec/')
    };

    static createVideo(data: any): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/alumni/spec/', data)
    };

    static updateVideo(id: number, data: any): Promise<AxiosResponse<any>> {
        return $api.patch<any>(`api/alumni/spec/${id}`, data)
    };

    static removeVideo(id: number): Promise<AxiosResponse> {
        return $api.delete(`api/alumni/delete/${id}`)
    };

};